import FeaturedVideoIcon from "@mui/icons-material/FeaturedVideo";
import HomeIcon from "@mui/icons-material/Home";
import ReceiptIcon from "@mui/icons-material/Receipt";
import SettingsIcon from "@mui/icons-material/Settings";
import PeopleIcon from "@mui/icons-material/People";

export default [
  {
    path: "/app",
    key: "home",
    title: "Home",
    muiIcon: HomeIcon,
    module: "any",
    action: "any",
    exact: true,
  },
  { title: "divider" },
  {
    path: "/app/schools",
    key: "schools",
    title: "Schools",
    muiIcon: SettingsIcon,
    module: "school_mgt",
    action: "action_list",
    exact: true,
  },
  {
    path: "/app/agents",
    key: "agencies",
    title: "Resellers",
    muiIcon: PeopleIcon,
    module: "agent_mgt",
    action: "action_list",
    exact: true,
  },
  {
    path: "/app/settings",
    key: "settings",
    title: "Settings",
    muiIcon: SettingsIcon,
    module: [
      "user_roles",
      "payment_gateways",
      "user_logins",
      "agent_mgt",
      "user_permissions",
    ],
    action: "action_list",
    exact: true,
  },
];
